import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';
import { getImageFile } from '../helpers/fileHelpers';

export class Image {
		constructor(doc) {
			this.label = null
			this.altitudeElevationLinearMeasure = null
			this.imageCaptionCommentDescription = null
			this.imageCategoryType = null
			this.imageDatetime = null
			this.imageFileLocationIdentifier = null
			this.latitudeIdentifier = null
			this.longitudeIdentifier = null
			this.MIMETypeIdentifier = null
			// these are added for processing convenience
			this.imageData = null;
			this.imageHeight = null;
			this.imageWidth = null;
			this.imageSrc = null;
			this.imageSourceCaption = "";

			this.label = x.getStringAttribute(doc,"xlink:label");
			this.altitudeElevationLinearMeasure = x.getMISMOMeasureElement(doc, "./ns:AltitudeElevationLinearMeasure");
			this.imageCaptionCommentDescription = x.getStringElement(doc, "./ns:ImageCaptionCommentDescription");
			this.imageCategoryType = x.getStringElement(doc, "./ns:ImageCategoryType");
			this.imageDatetime = x.getStringElement(doc, "./ns:ImageDatetime");
			this.imageFileLocationIdentifier = x.getStringElement(doc, "./ns:ImageFileLocationIdentifier");
			this.latitudeIdentifier = x.getStringElement(doc, "./ns:LatitudeIdentifier");
			this.longitudeIdentifier = x.getStringElement(doc, "./ns:LongitudeIdentifier");
			this.MIMETypeIdentifier = x.getStringElement(doc, "./ns:MIMETypeIdentifier");

			getImageFile(this.imageFileLocationIdentifier).then((data) => {
				if (data.data) {
					this.imageHeight = data.height;
					this.imageWidth = data.width;
					this.imageImg = data.img;
					this.imageData = data.data;
				} else {
					console.log("Missing image data:", this.imageFileLocationIdentifier);
				}
			});
		}

	 	GetCategoryType()
		{
			return h.descriptionOrOther(this.imageCategoryType, this.imageCategoryTypeOtherDescription);
		}

}

